//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SidebarHeader from '@/components/SidebarHeader'
import SearchResult from '@/components/SearchResult'
import { getRelativeDate } from '@/utils/swoop'
import { mapState } from 'vuex'
import { ApolloClient } from '@/vue-apollo'
import { gql } from '@apollo/client/core'

export default {
  name: 'Sidebar',

  components: {
    SidebarHeader,
    SearchResult
  },

  data() {
    return {
      records: []
    }
  },

  computed: {
    ...mapState({
      sidebarTags: state => state.sidebarTags,
      sidebarSearch: state => state.sidebarSearch
    })
  },

  watch: {
    sidebarTags() {
      this.searchTickets()
    },
    sidebarSearch() {
      this.searchTickets()
    }
  },

  methods: {
    statusColor(status) {
      if (status === 'OPEN') {
        return 'green'
      } else if (status === 'CLOSED') {
        return 'grey'
      }
    },

    dateCreated(record) {
      return getRelativeDate(record.created_at)
    },

    getTickets(page = 1) {
      return ApolloClient.query({
        query: gql`
          query Query($search: String, $status: [String], $page: Int) {
            ticketSearch(search: $search, status: $status, page: $page) {
              data {
                id
                name
                parent
                ticket_parent {
                  ... on ServiceLocation {
                    name(short: true)
                  }
                  ... on Site {
                    name
                  }
                  ... on Service {
                    name
                  }
                }
                customer_ticket_id
                status
                state
                created_at
                service_id
                workflow {
                  id
                  name
                }
              }
            }
          }
        `,
        variables: {
          search: this.sidebarSearch,
          status: this.sidebarTags,
          page: page
        }
      })
    },

    loadMoreTickets(index, done) {
      this.getTickets(index).then(result => {
        const records = result?.data.ticketSearch?.data || []
        if (records.length) {
          this.records = this.records.concat(records)
          done()
        } else {
          done(true)
        }
      })
    },

    searchTickets() {
      this.records = []
      this.$refs.infinityScroll.reset()
      this.$refs.infinityScroll.resume()
      this.$refs.infinityScroll.trigger()
    }
  }
}
